import { render, staticRenderFns } from "./ViewDocument.vue?vue&type=template&id=73f21206&scoped=true&"
import script from "./ViewDocument.vue?vue&type=script&lang=js&"
export * from "./ViewDocument.vue?vue&type=script&lang=js&"
import style0 from "./ViewDocument.vue?vue&type=style&index=0&id=73f21206&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f21206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73f21206')) {
      api.createRecord('73f21206', component.options)
    } else {
      api.reload('73f21206', component.options)
    }
    module.hot.accept("./ViewDocument.vue?vue&type=template&id=73f21206&scoped=true&", function () {
      api.rerender('73f21206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/knowledge/viewKnowledge/documents/ViewDocument.vue"
export default component.exports